import { render, staticRenderFns } from "./PushMessageManager.vue?vue&type=template&id=44303b44&scoped=true"
import script from "./PushMessageManager.vue?vue&type=script&lang=js"
export * from "./PushMessageManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44303b44",
  null
  
)

export default component.exports